import React, { useState } from 'react';
import { Route, Calendar } from 'lucide-react';
import { AppShell } from '../../components/layout/AppShell';
import { PageLayout } from '../../components/common/PageLayout';
import { PAGE_COLORS } from '../../utils/pageColors';
import { DeliveryManagementTabs } from '../../components/delivery-management/DeliveryManagementTabs';
import { ManageRoutes } from './ManageRoutes';
import { BookingDetails } from './BookingDetails';

type DeliveryManagementTab = 'manage-routes' | 'booking-details';

const DELIVERY_MANAGEMENT_TABS = [
  { key: 'manage-routes' as const, label: 'Manage Routes', icon: Route, color: 'blue' },
  { key: 'booking-details' as const, label: 'Booking Details', icon: Calendar, color: 'green' },
];

export const DeliveryManagementPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<DeliveryManagementTab>('manage-routes');

  return (
    <AppShell>
      <PageLayout
        title="Delivery Management"
        subtitle="Manage delivery routes and schedules"
        bgColor={PAGE_COLORS.delivery.bgColor}
        textColor={PAGE_COLORS.delivery.textColor}
        borderColor={PAGE_COLORS.delivery.borderColor}
        icon={<Route className="w-6 h-6" />}
      >
        {/* Tab Navigation */}
        <DeliveryManagementTabs 
          tabs={DELIVERY_MANAGEMENT_TABS}
          activeTab={activeTab}
          onTabChange={(tab) => setActiveTab(tab)}
        />
        
        {/* Tab Content */}
        {activeTab === 'manage-routes' && <ManageRoutes />}
        {activeTab === 'booking-details' && <BookingDetails />}
      </PageLayout>
    </AppShell>
  );
};
